// tab: 'discussion' or 'internal_notes'
// 'discussion' == guest
// 'internal_notes' == team

import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import {connect,  useDispatch, useSelector } from 'react-redux';
import { Button, Table, Card, Spinner, Image, Row, Col, SplitButton, Dropdown, DropdownButton, ButtonGroup } from 'react-bootstrap';
import { buttonClassForContentGroupAction } from '../../../utils/contentGroupUtils';
import { workspaceSizeAlert } from '../../../utils';
import { alertActions, commentActions, content_groupActions } from '../../../actions';
import { buildFormDataFromObject } from '../../../utils/commonUtils';
import { Capitalization } from '../../../utils/capitalization';
import { reduxForm, Field, reset, initialize, change, submit } from "redux-form";
import { validation } from "../../../shared/form-validations";
import { FieldUserTagSupport } from '../../../helpers/field_user_tag_support'
import { useInterval, ReplyContainer, ChatMessageList, RedDot } from '../../../components';
import { UserDropdown, ImagePopup, ElementTooltip } from '../../../components';
import { SmileIcon } from '../../../components/icons/SmileIcon';
import {PaperClipIcon} from '../../../components/icons/PaperClipIcon';
import { DraftCommentIcon } from '../../../components';
import { commentActionConstants, contentConstants, mediaQueryConstants, tooltipConstants, userConstants } from '../../../constants'
import EmojiPicker, {
  EmojiStyle,
  SkinTones,
  Theme,
  Categories,
  EmojiClickData,
  Emoji,
  SuggestionMode,
  SkinTonePickerLocation
} from "emoji-picker-react";
import autosize from "autosize";
import Smilly from "../../../images/icons/emoji.svg";
import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';
import { ChatContext } from "../../../contexts/ChatContext";
import { 
  getChatPreText 
} from "../../../utils/";
import { createCancelToken } from '../../../utils/Axios';
import FormAttachmentThumbnails from './sections/form_attachment_thumbnails';
import { imageExtentionsConstants } from "../../../constants";
import { filterByImages, filterByNotImages } from "./sections/form_attachment_thumbnails";
import { isDraftHasValue } from '../../../utils/isDraftHasValue';
import useRevisedCommentDraftHooks from '../../../hooks/useRevisedCommentDraftHooks';
import { removeDuplicateIdsinArray } from '../../../utils/removeDuplicateIdsinArray';
import { useMarkAsReadHook } from '../../../hooks/useMarkAsReadHook';
import useEmojiPopupHook from '../../../hooks/useEmojiPopupHook';
import useCommentActionCable from '../../../hooks/useCommentActionCable';

const addBreakLine = (text) => {
  if (!text) return '';

  const html = text.replace(/(?:\r\n|\r|\n)/g, "<br>");

  return html;

}

function ChatMessage(props) {
  const dispatch = useDispatch();
  const isLargeScreen = useMediaQuery({ query: `(max-width: ${mediaQueryConstants.LARGE}px)` });
  const isMediumScreen = useMediaQuery({ query: `(max-width: ${mediaQueryConstants.MEDIUM}px)` });
  // const { workspace_id } = useParams();
  const {
    workspace_id,
    workspace,
    handleSubmit,
    initialComments,
    content_group,
    can_add,
    selected_content_id,
    setSelectedContentId,
    content_group_id,
    activeTab,
    setActiveTab,
    can_access_comment,
    can_access_team_comment,
    can_access_show_team_comment,
    can_access_accept_request_revision,
    can_access_submit_approval,
    can_access_accept_revision,
    setChatFocused,
    has_next_page,
    created_comment,
    currentWorkSpace,
    highlighted_comment,
    cardTitleRef,
    deleted_comment,
    updated_comment,
    draft_comment_loading,
    update_comment_loading,
    draft_attachment_loading,
    draft_render_loading,
    internal_draft,
    partner_draft,
    readOnly = false
  } = props

  const [showActivities, setShowActivities] = useState(false);
  const [sessionId, setSessionId] = useState(localStorage.getItem("set_content_id"));
  const chatFormRef = useRef();
  const inputRef = useRef();
  const tagUserDropdown = useRef();
  const scrollContainer = useRef();
  const [shouldBeFixed, setShouldBeFixed] = useState(false);
  const [current_page, setCurrentPage] = useState(1);
  const emojiPickerRef = useRef();
  const PER_PAGE = 10;

  const COMMENT_INTERVAL_MS = 60000; // 1 minute
  const bottomRef = useRef(null);
  const REPLY_ATTACHMENT_MAX_COUNT = 5;
  const REPLY_IMAGE_MAX_COUNT = 20;
  const {
    ATTACHMENT_MAX_SIZE,
    IMAGE_MAX_SIZE,
    BUSINESS_ATTACHMENT_MAX_SIZE,
    BUSINESS_IMAGE_MAX_SIZE
  } = contentConstants;

  // States
  const [tagSelectorText, setTagSelectorText] = useState("");
  const [isTagSelectorOpen, setTagSelectorOpen] = useState(false);
  const [shiftHeld, setShiftHeld] = useState(false);
  const [commentToReplyId, setCommentToReplyId] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [commentToEdit, setCommentToEdit] = useState(null);
  const [fileLimit, setFileLimit] = useState(false);
  const commentRefs = useRef(new Array());
  const [highlightedCommentId, setHighlightedCommentId] = useState(null);
  const [approveDropdownSelectedOption, setApproveDropdownSelectedOption] = useState("Select");
  const [submitDropdownSelectedOption, setSubmitDropdownSelectedOption] = useState("Comment");
  const updateCommentBtnTextValues = ['Save', 'Update Cancel']
  const [requestDropdownSelectedOption, setRequestDropdownSelectedOption] = useState("Accept Request");
  const [chatText, setChatText] = useState();
  const [showApprovalDropdown, setShowApprovalDropdown] = useState(false);
  const [initialHighlightComment, setInitialHighlightComment] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);

  // Refs
  const submitBtnRef = useRef(null);
  const scrollContainerRef = useRef();
  const cancelTokenRef = useRef(createCancelToken());
  const tabCancelTokenRef = useRef(createCancelToken());
  const updateDraftTokenRef = useRef(createCancelToken());
  const activeTabRef = useRef();
  const currentPageRef = useRef(current_page);
  const showActivitiesRef = useRef(showActivities);
  const updateDraftTimerRef = useRef();
  const updateDraftAttachmentTimerRef = useRef();
  const isRunningCommentRef = useRef(false); 
  const chatInputRef = useRef(false);
  const chatLoadedRef = useRef(false);
  const chatAliveRef = useRef(true);

  // Hooks
  const { 
    showEmojiPopup, 
    setShowEmojiPopup,
    handleShowEmojis,
    customEmojiClassname,
    onEmojiClick
  } = useEmojiPopupHook({emojiRef: emojiPickerRef, inputRef, scrollContainerRef, setChatText});

  const markAsRead = useMarkAsReadHook({
      dispatch,
      workspace_id,
      content_group_id,
      triggerRef: bottomRef,
      activeTab
  });

  const { connected } = useCommentActionCable({ 
                                                card_id: content_group_id, 
                                                workspace_id,
                                                show_activities: showActivitiesRef.current,
                                                per_page: currentPageRef.current * PER_PAGE,
                                                cancel_token: cancelTokenRef.current.token,
                                              });

  // Redux
  const { comments } = useSelector(state => state.comment);

  const setupChatContent = useCallback((newDraft) => {
    if (inputRef.current) {

      inputRef.current.innerHTML = addBreakLine(newDraft.description);
      setChatText(newDraft.description)
      setCommentToReplyId(newDraft.parent_id)
      setUploadedFiles(newDraft.attachments)
    }
  }, [inputRef.current]);

  const resetChatInputRef = () => {
    chatInputRef.current = false;
  }

  const { draft: draft_comment } = useRevisedCommentDraftHooks(
    React.useMemo(() => ({
      workspace_id: workspace_id,
      content_group_id: content_group_id,
      update_draft_token: updateDraftTokenRef.current,
      inputRef: inputRef.current,
      resetChatInputRef,
      chatInputRef: chatInputRef.current,
      uploadedFiles,
      chatText,
      setChatText,
      commentToReplyId,
      setupChatContent,
      commentToEdit,
      readOnly
    }), [
      workspace_id,
      content_group_id,
      updateDraftTokenRef.current,
      inputRef.current,
      resetChatInputRef,
      chatInputRef.current,
      uploadedFiles,
      chatText,
      setChatText,
      commentToReplyId,
      setupChatContent,
      commentToEdit,
      readOnly
    ])
  );

  const getCommentRef = (element, id) => {
    let index = commentRefs.current.findIndex((el) => el.id == id)
    if (index == -1){
      commentRefs.current.push({ el: element, id: id})
    } else {
      if (commentRefs.current[index]){
          commentRefs.current[index] = { el: element, id: id}
      }
    }
  }

  /*
    Status Change Modal
  */
  const statuses = [
    'request_revision',
    'submit_for_approval',
    'void_submit',
    'approve_content_group',
    'accept_request',
    'reject_request'
  ]

  var reader = new FileReader();

  const uploadFileInputRef = useRef();

  const downHandler = ({key}) => {
    if (key === 'Shift') {
      setShiftHeld(true);
    }
  }

  const upHandler = ({key}) => {
    if (key === 'Shift') {
      setShiftHeld(false);
    }
  }

  const nextCommentPage = () => {
    if(isScrolling) return;
    
    let next_page = current_page + 1
    currentPageRef.current = next_page;
    setCurrentPage(next_page)

    const onBefore = () => {
      dispatch({ type: userConstants.COMMENT_LOADING })
    }

    const onSuccess = (res) => {
      dispatch({ type: commentActionConstants.SET_CAN_ACCESS_COMMENT, payload: res.data.can_access_comment });
      dispatch({ type: userConstants.COMMENT_LOADING_FINISHED });
      dispatch({ type: userConstants.UPDATE_COMMENT_LOADING_FINISHED });
      dispatch({ type: commentActionConstants.SET_HAS_NEXT_PAGE, payload: res.data.has_next_page });

      //if(isRunningCommentRef.current) return;
      dispatch({ type: commentActionConstants.ADD_COMMENTS, payload: res.data.data });

    }

    const onError = (response) => {
      dispatch({ type: userConstants.COMMENT_FAILURE, payload: response.data.message});
      dispatch(alertActions.error(response.data.message));
    }

    const params = {
      workspace_id,
      content_group_id,
      params: {
        show_activities: showActivities,
        chat_status: activeTab,
        page: next_page,
        per_page: PER_PAGE
      },
      cancel_token: cancelTokenRef.current.token,
      onBefore,
      onSuccess,
      onError
    }
    
    dispatch(commentActions.getRevisedCommentControlled(params));
  }

  useEffect(() => {
    dispatch({ type: userConstants.COMMENT_TAB_LOADING })

    if(content_group_id){
      if(highlighted_comment?.id && initialHighlightComment === false){
        if(highlighted_comment?.internal === '1' && can_access_team_comment && can_add){
          setActiveTab("internal_notes")
        } else {
          setActiveTab("discussion")
        }
      } else if(!isLargeScreen) {
        if(can_access_team_comment && can_add){
          setActiveTab("internal_notes")
        } else {
          setActiveTab("discussion")
        }
      }
    }

    setTimeout(() => {
      dispatch({ type: userConstants.COMMENT_TAB_LOADED })
    }, 100);
  }, [content_group_id, isLargeScreen]);

  useEffect(() => {
    if(activeTab !== "" && connected){
      isRunningCommentRef.current = true;
      
      handleTab(activeTab)
      activeTabRef.current = activeTab
      handleCloseComment();
    }

    return () => {
      handleCloseComment();

      cancelTokenRef.current.cancel('Operation canceled by the user');
      cancelTokenRef.current = createCancelToken();

      tabCancelTokenRef.current.cancel('Operation canceled by the user');
      tabCancelTokenRef.current = createCancelToken();

      isRunningCommentRef.current = false;
      setIsScrolling(false);
    }
  }, [activeTab, connected]);

  useEffect(() => {
    chatAliveRef.current = true;
    let timeoutId;

    const fetch = async () => {
      if(content_group_id && !props.loading){
        const page = 1;
        const load = false;

        const onSuccess = (res) => {
          dispatch({ type: userConstants.COMMENT_LOADING_FINISHED });
          dispatch({ type: userConstants.UPDATE_COMMENT_LOADING_FINISHED });

          if(!isRunningCommentRef.current) return;
          if (!chatAliveRef.current) return;

          dispatch({ type: commentActionConstants.SET_COMMENTS, payload: res.data.data });
          dispatch({ type: commentActionConstants.SET_HAS_NEXT_PAGE, payload: res.data.has_next_page });
          dispatch({ type: commentActionConstants.SET_CAN_ACCESS_COMMENT, payload: res.data.can_access_comment });

        }
        const onError = (response) => {
          dispatch({ type: userConstants.COMMENT_FAILURE, payload: response.data.message});
          dispatch(alertActions.error(response.data.message));
        }

        const params = {
          workspace_id,
          content_group_id,
          params: {
            chat_status: activeTabRef.current,
            show_activities: showActivitiesRef.current,
            page,
            per_page: currentPageRef.current * PER_PAGE
          },
          cancel_token: cancelTokenRef.current.token,
          onSuccess,
          onError
        }
        dispatch(commentActions.getRevisedCommentControlled(params));
      }

      if (chatAliveRef.current) {
        timeoutId = setTimeout(fetch, COMMENT_INTERVAL_MS);
      }
    }

    fetch();

    return () => {
      chatAliveRef.current = false;
      cancelTokenRef.current.cancel('Operation canceled by the user');
      cancelTokenRef.current = createCancelToken();

      tabCancelTokenRef.current.cancel('Operation canceled by the user');
      tabCancelTokenRef.current = createCancelToken();

      isRunningCommentRef.current = false;
      clearInterval(timeoutId);
      dispatch({ type: commentActionConstants.CLEAR_COMMENTS });
    }
  }, []);

  const handleEditComment = (data) => {
    setCommentToEdit(data)
    setupChatContent(data)
    //setCommentToReplyId(null);
    //setUploadedFiles([]);

    //if(data?.attachments){
    //  setUploadedFiles(data?.attachments)
    //}
 
    //inputRef.current.innerHTML = data.description
  }

  const handleCloseComment = (e) => {
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }


    setCommentToEdit(null)
    setCommentToReplyId(null);
    setUploadedFiles([]);
    setIsDisabled(false);
 
    if(inputRef.current) inputRef.current.innerHTML = '';
  }

  useEffect(() => {
    if(sessionId == content_group_id) {
      setShowActivities(true)
      showActivitiesRef.current = true;
    }else {
      setShowActivities(false)
      showActivitiesRef.current = false
    }
  }, [sessionId]);

  useEffect(() => {
    if(created_comment){
      bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
    }
  }, [created_comment]);

  const uniqueComments = React.useMemo(() => removeDuplicateIdsinArray(comments), [comments]);

  useEffect(() => {
    if(initialHighlightComment === false && highlighted_comment?.id && commentRefs.current?.length > 0){
      if(
          (highlighted_comment?.internal !== '1' && activeTab === 'discussion') ||
          (highlighted_comment?.internal === '1' && activeTab === 'internal_notes')
        ){
          setInitialHighlightComment(true);

          setTimeout(() => {
            scrollToComment(highlighted_comment?.id);
          }, 1000) // Wait for the page to render
        }
    }
  }, [comments]);

  const clearMessage = () => {
    inputRef.current.innerHTML = ""
  }

  const [isDisabled, setIsDisabled] = useState(false);

  const isSubmitDisabled = useCallback(() => {
    return (isDisabled || draft_comment_loading || update_comment_loading || draft_attachment_loading || draft_render_loading || connected === false);
  }, [
      isDisabled, 
      draft_comment_loading, 
      update_comment_loading, 
      draft_attachment_loading, 
      draft_render_loading,
      connected
     ]
  );

  const processCommentMobileSubmit = (e) => {
    if(inputRef.current.innerHTML.length > 0 || uploadedFiles.length > 0) {
      submitProcess({description: inputRef.current.innerHTML})
    }
  }

  const handleTab = (status) => {
    if(status === "" || status === null) return;
    if (!!inputRef.current) {
      inputRef.current.innerHTML = ""
    }
    const load = false;
    const start_page = 1;

    setTagSelectorOpen(false)
    setCommentToReplyId(null)
    setCurrentPage(start_page);
    currentPageRef.current = start_page;

    const onSuccess = (res) => {
      dispatch({ type: userConstants.COMMENT_LOADING_FINISHED });
      dispatch({ type: userConstants.UPDATE_COMMENT_LOADING_FINISHED });

      if(!isRunningCommentRef.current) return;
      
      dispatch({ type: commentActionConstants.SET_HAS_NEXT_PAGE, payload: res.data.has_next_page });
      dispatch({ type: commentActionConstants.SET_CAN_ACCESS_COMMENT, payload: res.data.can_access_comment });
      dispatch({ type: commentActionConstants.SET_COMMENTS, payload: res.data.data });

    }

    const onError = (response) => {
      dispatch({ type: userConstants.COMMENT_FAILURE, payload: response.data.message});
      dispatch(alertActions.error(response.data.message));
    } 

    const params = {
      workspace_id,
      content_group_id,
      params: {
        chat_status: status,
        show_activities: showActivities,
        page: start_page,
        per_page: PER_PAGE
      },
      cancel_token: tabCancelTokenRef.current.token,
      onSuccess,
      onError
    }

    dispatch(commentActions.getRevisedCommentControlled(params));
  }

  const canAccessInternalNotes = () => {
    return can_add;
  };

  const canAccessPartnerNotes = () => {
    return true;
  };

  /*
    Popup Modal
  */
  const [imagePopup, setImagePopUp] = useState({
    show: false,
    image_url: null,
  });

  const renderParentComment = (comment) => {
    let parent = null;

    if (comment?.parent !== undefined){
      parent = comment.parent

      return <ReplyContainer data={parent} scrollToComment={scrollToComment}/>
    } else {
      if(comment.parent_id === null) return <></>;

      parent = comments?.find( (c) => c.id === comment.parent_id)

      if (parent === null || parent === undefined) return <></>;

      const handleClose = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setCommentToReplyId(null)
        chatInputRef.current = true;
      }

      return <ReplyContainer data={parent} scrollToComment={scrollToComment} handleClose={handleClose}/>
    }
  }

  const renderCommentToEdit = (comment) =>{
    return <ReplyContainer data={comment} scrollToComment={scrollToComment} handleClose={handleCloseComment}/>
  }

  const scrollToComment = (comment_id) => {
    setIsScrolling(true);
    setTimeout(() => {
      let element = commentRefs.current.find((el) => el.id == comment_id)

      if(element !== undefined){
        element?.el?.scrollIntoView({ behavior: "smooth", block: "center" });
        higlightComment(element.id);
      } else {
        const callback = (result) => {
          dispatch({ type: commentActionConstants.SET_COMMENTS, payload: result.data });
          setCurrentPage(result.new_page)
          currentPageRef.current = result.new_page;
          scrollToComment(comment_id)
        }

        dispatch(commentActions.showComment(workspace_id, content_group_id, comment_id, showActivities, activeTab, current_page, PER_PAGE, callback))
      }
    }, 0);

    setTimeout(() => {
      setIsScrolling(false);
    }, 1500);
  }

  const higlightComment = (id) => {
    setHighlightedCommentId(id)
    setTimeout(function(){setHighlightedCommentId(null)},2000);
  }

  const selectCommentToReply = (comment_id, ref) => {
    chatInputRef.current = true;
    if (comment_id) {
      let range = document.createRange();
      range.selectNodeContents(inputRef.current);
      range.collapse(false);
      let selection = window.getSelection();
      selection.removeAllRanges();

      const textLength = inputRef.current.innerHTML.length;
      selection.addRange(range);
      inputRef.current.focus();
    }

    setCommentToReplyId(comment_id)
  }

  const handleActive = () => {
    let showActivitiesTemp = !showActivities;
    setShowActivities(showActivitiesTemp)
    showActivitiesRef.current = showActivitiesTemp;
    if(showActivities){
      localStorage.removeItem("set_content_id");
    }else {
      localStorage.setItem("set_content_id", content_group_id)
    }

    if(!props.loading){
      const load = true;

      const onBefore = () => {
        dispatch({ type: userConstants.COMMENT_LOADING })
      }

      const onSuccess = (res) => {
        dispatch({ type: userConstants.COMMENT_LOADING_FINISHED });
        dispatch({ type: userConstants.UPDATE_COMMENT_LOADING_FINISHED });

        if(!isRunningCommentRef.current) return;
        
        dispatch({ type: commentActionConstants.SET_HAS_NEXT_PAGE, payload: res.data.has_next_page });
        dispatch({ type: commentActionConstants.SET_CAN_ACCESS_COMMENT, payload: res.data.can_access_comment });
        dispatch({ type: commentActionConstants.SET_COMMENTS, payload: res.data.data });
        let timeout = setTimeout(() => {
                        dispatch({ type: commentActionConstants.UPDATE_COMMENTS, payload: res.data.data });
                      }, 0);

        clearTimeout(timeout)
      }

      const params ={
        workspace_id,
        content_group_id,
        params: {
          show_activities: showActivitiesTemp,
          chat_status: activeTab,
          page: 1,
          per_page: current_page * PER_PAGE
        },
        cancel_token: cancelTokenRef.current.token,
        onBefore,
        onSuccess,
      }

      dispatch(commentActions.getRevisedCommentControlled(params));
    }
  }


  const updateTagSelector = (tag) => {
    setTagSelectorText(tag)
    setTagSelectorOpen(true)

    if(scrollContainerRef.current.scrollHeight > 300) {
      setShouldBeFixed(true)
    }else {
      setShouldBeFixed(false)
    }
  }

  const [searchTag, setSearchTag] = useState()
  const onKeyDown = (event) => {
    downHandler(event)
    chatInputRef.current = true;

    if (isTagSelectorOpen && ['ArrowDown', 'ArrowUp', 'Enter'].includes(event.key)) {
      event.preventDefault()
      event.stopPropagation()
      if (tagUserDropdown.current) {
        tagUserDropdown.current.handleKeyUp(event)
      }
    } else if (['Backspace'].includes(event.key) && false) {
      var selection = window.getSelection()
      if (!selection.isCollapsed || !selection.rangeCount) {
        return;
      }

      var curRange = selection.getRangeAt(0)
      if (curRange.commonAncestorContainer.nodeType == 3 && curRange.startOffset > 0) {
        return;
      }

      var range = document.createRange()
      if (selection.anchorNode != event.target) {
        range.selectNodeContents(event.target)
        range.setEndBefore(selection.anchorNode)
      } else if (selection.anchorOffset > 0) {
        range.setEnd(event.target, selection.anchorOffset)
      } else {
        return;
      }

      var previousNode = range.lastChild
      if (previousNode && previousNode.contentEditable == 'false') {
        range.deleteContents()
        event.preventDefault()
      }
    }

    if (event.key === "Enter" && event.shiftKey) {
      event.preventDefault(); // prevent default behavior
      const sel = window.getSelection();
      const range = sel.getRangeAt(0);

      // insert <br>
      const br = document.createElement("br");
      range.insertNode(br);

      // move caret just after <br>
      range.setStartAfter(br);
      range.collapse(true);

      sel.removeAllRanges();
      sel.addRange(range);
    }
  }

  const commentPlaceholder = () => {
    return 'Comment or mention by typing @';
  }

  const handleUploadFiles = files => {
       const uploaded = [...uploadedFiles];
       let limitExceeded = false;
       const is_workspace_personal = currentWorkSpace?.personal;
       const image_size_limit = is_workspace_personal ? IMAGE_MAX_SIZE : BUSINESS_IMAGE_MAX_SIZE;
       const attachment_size_limit = is_workspace_personal ? ATTACHMENT_MAX_SIZE : BUSINESS_ATTACHMENT_MAX_SIZE;

       files.some((file) => {
          let filename = file?.id ? file.filename : file.file.name
          let is_image = imageExtentionsConstants.some(extension => filename.toLowerCase().endsWith(extension.toLowerCase()))

          if (uploaded.findIndex((f) => f.id === undefined && f.file.name === file.file.name) === -1) {
            uploaded.push(file);

            if (is_image){
              let uploaded_images = filterByImages(uploaded);
              if (uploaded_images.length === REPLY_IMAGE_MAX_COUNT) setFileLimit(true);
              if (uploaded_images.length > REPLY_IMAGE_MAX_COUNT) {
                  alert(`You can only add a maximum of ${REPLY_IMAGE_MAX_COUNT} images`);
                  setFileLimit(false);
                  limitExceeded = true;
              }
              if (file.file.size > image_size_limit){
                alert(`Maximum file size is ${is_workspace_personal ? '5' : '10'}MB.`);
                setFileLimit(false);
                limitExceeded = true;
              }
            } else {
              let uploaded_files = filterByNotImages(uploaded);
              if (uploaded_files.length === REPLY_ATTACHMENT_MAX_COUNT) setFileLimit(true);
              if (uploaded_files.length > REPLY_ATTACHMENT_MAX_COUNT) {
                  alert(`You can only add a maximum of ${REPLY_ATTACHMENT_MAX_COUNT} files`);
                  setFileLimit(false);
                  limitExceeded = true;
              }

              if (file.file.size > attachment_size_limit){
                alert(`Maximum file size is ${is_workspace_personal ? '5' : '10'}MB.`);
                setFileLimit(false);
                limitExceeded = true;
              }
            }
          }
       })

       if (!limitExceeded) {
        setUploadedFiles(uploaded);
        inputRef.current.focus();
       }

  }

  const handleFileEvent = (e) => {
    workspaceSizeAlert(currentWorkSpace);

    const chosenFiles = Array.prototype.slice.call(e.target.files)
    let mappedFiles = Array.prototype.slice.call(chosenFiles).map((f) => ({file: f}))
    handleUploadFiles(mappedFiles);
  }

  let chatContexts = {
    activeTab: activeTab,
    can_access_comment: can_access_comment,
    setCommentToEdit: setCommentToEdit,
    commentToEdit: commentToEdit,
    handleEditComment: handleEditComment
  }

  const resetDraftToken = () => {
    updateDraftTokenRef.current.cancel('Comment is being submitted');
    updateDraftTokenRef.current = createCancelToken();
  }

  const removeHandleFileEvent =(file)=> {
    var array = [...uploadedFiles]; // make a separate copy of the array
    chatInputRef.current = true;

    if(file?.id){
      var index = array.findIndex(x => x.id === file.id);
      if (index !== -1) {
        array[index]._destroy = true
  
        setUploadedFiles(prevState => array);
        uploadFileInputRef.current.value = ''
      }
    } else {
      var index = array.indexOf(file)

      if (index !== -1) {
        array.splice(index, 1);
  
        setUploadedFiles(array);
        uploadFileInputRef.current.value = ''
      }
    }
  }

  const renderButtonContentForApprovalAction = (action) => {
    switch(action) {
        case 'Accept Request':
          return <>
            Accept
          </>
        break;
        case 'Reject Request':
          return <>
            Reject
          </>
        break;
        case 'Approve':
          return <>
            Approve
          </>
          break;
        case 'Request Revisions':
          return <>
            Reject
          </>
          break;
        case 'Comment':
          return <>
            Comment
          </>
          break;
        case 'Void Submission':
        case updateCommentBtnTextValues[1]:
          return <>
            Cancel
          </>
          break;
        default:
          return action;
    }
  }

  const isApprovalActionDisabled = () => {
    return content_group.stage.status === 'pending'
  }
  const cancelDraft = () => {
    resetDraftToken();
    if(updateDraftTimerRef.current){
      clearTimeout(updateDraftTimerRef.current)
    }

    if(updateDraftAttachmentTimerRef.current){
      clearTimeout(updateDraftAttachmentTimerRef.current)
    }
  }

  const isChatInputEmpty = useCallback(() => {
    return inputRef.current?.innerHTML.trim() === '<br>' || inputRef.current?.innerHTML.trim().length === 0;
  }, [inputRef]);

  const isApprovalButtonDisabled = useCallback(() => {
    return isSubmitDisabled() || (isChatInputEmpty() && uploadedFiles.length === 0 );
  }, [isSubmitDisabled, uploadedFiles, isChatInputEmpty]);

  const submitProcess = useCallback((values) => {
    if (isApprovalButtonDisabled()) return;
    
    if (!isSubmitDisabled() && (uploadedFiles.length > 0 || values.description.trim() !== '<br>' || values.description.length > 0)) {
      setIsDisabled(true);
      cancelDraft();
      
      let formData = new FormData();
      let objValues = values;

      objValues.internal = activeTab === "internal_notes";
      objValues.parent_id = commentToReplyId;
      objValues.attachments_attributes = uploadedFiles;

      if (draft_comment) {
        objValues.draft_comment_id = draft_comment?.id;
      }

      buildFormDataFromObject(formData, objValues, "comment");

      uploadFileInputRef.current.value = '';
      dispatch(
        commentActions.createComment(
          formData,
          workspace_id,
          content_group_id,
          activeTab,
          current_page,
          PER_PAGE,
          setIsDisabled
        )
      );
    }
  }, [
    isApprovalButtonDisabled,
    isSubmitDisabled,
    uploadedFiles,
    activeTab,
    commentToReplyId,
    draft_comment,
    dispatch,
    workspace_id,
    content_group_id,
    current_page,
    PER_PAGE,
    cancelDraft,
    setIsDisabled,
  ]);

  const handleApprovalAction = useCallback((action) => {
    if (isApprovalButtonDisabled()) return;

    if (action !== 'Select') setIsDisabled(true);

    cancelDraft();
    setTimeout(() => {
      let description = inputRef.current.innerHTML;
      let objValues = {};

      objValues.description = description;
      objValues.internal = false;
      objValues.is_notification = false;
      objValues.attachments_attributes = uploadedFiles;
      objValues.parent_id = commentToReplyId;

      if (draft_comment) {
        objValues.draft_comment_id = draft_comment?.id;
      }

      switch (action) {
        case 'Accept Request':
        case 'Accept':
          objValues.event_type = 'accept_request';
          dispatch(
            content_groupActions.acceptRequestContentGroup(
              content_group_id,
              workspace_id,
              content_group?.stage?.approved_content_group_stage_id,
              activeTab,
              objValues,
              setIsDisabled
            )
          );
          break;
        case 'Reject Request':
        case 'Reject':
          objValues.event_type = 'reject_request';
          dispatch(
            content_groupActions.rejectRequestContentGroup(
              content_group_id,
              workspace_id,
              content_group?.stage?.approved_content_group_stage_id,
              activeTab,
              objValues,
              setIsDisabled
            )
          );
          break;
        case 'Request Revisions':
        case 'Disapprove':
          objValues.event_type = 'request_revision';
          dispatch(
            content_groupActions.requestRevisionContentGroup(
              content_group_id,
              workspace_id,
              content_group?.stage?.approved_content_group_stage_id,
              activeTab,
              objValues,
              setIsDisabled
            )
          );
          break;
        case 'Comment':
          processCommentMobileSubmit();
          break;
        case 'Approve':
          objValues.event_type = 'approve';
          dispatch(
            content_groupActions.approveContentGroup(
              content_group_id,
              workspace_id,
              content_group?.stage?.approved_content_group_stage_id,
              activeTab,
              objValues,
              setIsDisabled
            )
          );
          break;
        case 'Void Submission':
        case 'Cancel':
          objValues.event_type = 'void_submission';
          dispatch(
            content_groupActions.voidSubmitContentGroup(
              content_group_id,
              workspace_id,
              content_group?.stage?.approved_content_group_stage_id,
              activeTab,
              objValues,
              setIsDisabled
            )
          );
          break;
        case 'Submit':
          objValues.event_type = 'submit_for_approval';
          dispatch(
            content_groupActions.submitContentGroup(
              content_group_id,
              workspace_id,
              content_group?.stage?.id,
              activeTab,
              objValues,
              setIsDisabled
            )
          );
          break;
        case 'Select':
          setShowApprovalDropdown((prevState) => true);
          return;
        case updateCommentBtnTextValues[0]:
          const callback = () => {
            handleCloseComment();
          };

          objValues.attachments_attributes = uploadedFiles.filter((file) => file?.id);
          objValues.uploaded_files = uploadedFiles.filter((file) => file?.id === undefined);

          let formData = new FormData();

          buildFormDataFromObject(formData, objValues, 'comment');

          dispatch(
            commentActions.updateComment(
              formData,
              workspace_id,
              content_group_id,
              commentToEdit?.id,
              callback
            )
          );
          break;
        case updateCommentBtnTextValues[1]:
          handleCloseComment();
          break;
        default:
          setIsDisabled(false);
      }

      setSelectedContentId(null);
      setCommentToReplyId(null);
      setUploadedFiles([]);
      setChatText('');
      clearMessage();
      uploadFileInputRef.current.value = '';
    }, 0);
  }, [
    uploadedFiles,
    chatText,
    draft_comment,
    commentToReplyId,
    content_group_id,
    workspace_id,
    content_group,
    activeTab,
    dispatch,
    setIsDisabled,
    setShowApprovalDropdown,
    updateCommentBtnTextValues,
    handleCloseComment,
    setSelectedContentId,
    setCommentToReplyId,
    setUploadedFiles,
    setChatText,
    clearMessage,
    uploadFileInputRef,
    inputRef?.current?.innerHTML,
    chatInputRef.current?.innerHTML,
    isApprovalButtonDisabled,
    isSubmitDisabled
  ]);

  const processCommentWebSubmit = useCallback((event) => {
    const elem = submitBtnRef.current.getElementsByClassName('submit_btn');
    if (
      ['Enter'].includes(event.key) &&
      (event.target.innerHTML.length > 0 || uploadedFiles.length > 0) &&
      !shiftHeld &&
      !isDisabled &&
      !draft_comment_loading &&
      !update_comment_loading &&
      !draft_attachment_loading &&
      !draft_render_loading &&
      !isMediumScreen
    ) {
      event.preventDefault();
      event.stopPropagation();
      if (elem) {
        handleApprovalAction(elem[0].getAttribute('actiontext'));
      }
    } else if (['Enter'].includes(event.key) && (shiftHeld || isMediumScreen)) {
      document.execCommand('insertLineBreak');
      event.preventDefault();
      event.stopPropagation();

      setChatText(inputRef.current.innerHTML);

      const range = document.createRange();
      const selection = window.getSelection();

      // Move range to the end of the editable div
      range.selectNodeContents(inputRef.current);
      range.collapse(false); // collapse to end

      // Remove old ranges and add the new one
      selection.removeAllRanges();
      selection.addRange(range);

      inputRef.current.focus();
    } else if (['Enter'].includes(event.key) && !shiftHeld) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, [
    uploadedFiles,
    shiftHeld,
    isDisabled,
    draft_comment_loading,
    update_comment_loading,
    draft_attachment_loading,
    draft_render_loading,
    isMediumScreen,
    handleApprovalAction,
    setChatText,
    inputRef.current
  ]);


  const approvalButtonVariant = () =>{
    return isApprovalButtonDisabled() ? 'gray' : buttonClassForContentGroupAction(approveDropdownSelectedOption)
  }

  const chatOnFocus = (e) => {
    setChatFocused(true)
  }

  const chatOnBlur = (e) => {
    setChatFocused(false)
  }

  const submitBtnText = (default_text) => {
    if(!isSubmitDisabled()) return default_text;

    if (draft_comment_loading || update_comment_loading ||  draft_render_loading){
      return  <>
                <Spinner animation="border" size="sm" as="span" className='mr-2'/>
                Saving...
              </>
    }

    if (connected === false){
      return  'Connecting...';
    }

    return  'Adding comment...';
  }

  const renderDropdown = (options, selectedOption, setSelectedOption, buttonVariant, isDisabled, isDropdownItemDisable) => (
    <Dropdown
      as={ButtonGroup}
      align="end"
      drop={isLargeScreen ? 'up' : 'down'}
      className={selectedOption}
      onToggle={(nextShow) => setShowApprovalDropdown(nextShow)}
      show={showApprovalDropdown}
    >
      <Button
        variant={buttonVariant}
        onClick={() => handleApprovalAction(selectedOption)}
        disabled={isDisabled}
        className="submit_btn fw-500"
        actiontext={selectedOption}
      >
        {submitBtnText(renderButtonContentForApprovalAction(selectedOption))}
      </Button>
      <Dropdown.Toggle split variant={buttonVariant} disabled={isDisabled} />
      <Dropdown.Menu className="text-left">
        {options.map((action, index) => (
          action !== selectedOption && (
            <Dropdown.Item
              onClick={() => setSelectedOption(action)}
              disabled={ isDropdownItemDisable ? isDropdownItemDisable(action) : false }
              key={`action_${index}`}
            >
              {renderButtonContentForApprovalAction(action)}
            </Dropdown.Item>
          )
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );

  const renderCommentSubmitButton = useCallback(() => {
    if (commentToEdit?.id) {
      return (
        <Button
          variant={buttonClassForContentGroupAction(updateCommentBtnTextValues[0])}
          onClick={() => handleApprovalAction(updateCommentBtnTextValues[0])}
          className="submit_btn fw-500"
          actiontext={updateCommentBtnTextValues[0]}
        >
          {submitBtnText(renderButtonContentForApprovalAction(updateCommentBtnTextValues[0]))}
        </Button>
      );
    }

    if (content_group?.require_approval_from_client && activeTab === 'discussion') {
      if (content_group?.stage?.submitted) {
        if (can_access_submit_approval) {
          if (content_group?.stage?.status === 'pending') {
            return renderDropdown(
              ['Accept Request', 'Reject Request', 'Comment'],
              requestDropdownSelectedOption,
              setRequestDropdownSelectedOption,
              buttonClassForContentGroupAction(requestDropdownSelectedOption),
              isApprovalButtonDisabled()
            );
          } else {
            return renderDropdown(
              ['Comment', 'Void Submission'],
              submitDropdownSelectedOption,
              setSubmitDropdownSelectedOption,
              buttonClassForContentGroupAction(submitDropdownSelectedOption),
              isApprovalButtonDisabled(),
              isApprovalActionDisabled()
            );
          }
        } else if (can_access_accept_request_revision) {
          if (content_group?.stage?.approved || content_group?.stage?.requested_revision ) {
            return (
              <Button
                variant="info"
                type="submit"
                disabled={isSubmitDisabled()}
                onClick={() => handleApprovalAction('Comment')}
                actiontext="Comment"
                className="submit_btn fw-500"
              >
                {submitBtnText('Comment')}
              </Button>
            );
          } else {
            return renderDropdown(
              ['Approve', 'Request Revisions', 'Comment'],
              approveDropdownSelectedOption,
              setApproveDropdownSelectedOption,
              approvalButtonVariant(),
              isApprovalButtonDisabled()
            );
          }
        } else {
          return (
            <Button
              variant="info"
              type="submit"
              disabled={isApprovalButtonDisabled()}
              onClick={() => handleApprovalAction('Comment')}
              actiontext="Comment"
              className="submit_btn fw-500"
            >
              {submitBtnText('Comment')}
            </Button>
          );
        }
      } else {
        if (can_access_submit_approval) {
          return (
            <Button
              variant="success"
              type="submit"
              disabled={isApprovalButtonDisabled()}
              onClick={() => handleApprovalAction('Submit')}
              actiontext="Submit"
              className="submit_btn fw-500"
            >
              {submitBtnText('Submit')}
            </Button>
          );
        } else {
          return (
            <Button
              variant="info"
              type="submit"
              disabled={isApprovalButtonDisabled()}
              onClick={() => handleApprovalAction('Comment')}
              actiontext="Comment"
              className="submit_btn fw-500"
            >
              {submitBtnText('Comment')}
            </Button>
          );
        }
      }
    } else {
      return (
        <Button
          variant="info"
          type="submit"
          disabled={isApprovalButtonDisabled()}
          onClick={() => handleApprovalAction('Comment')}
          actiontext="Comment"
          className="submit_btn fw-500"
        >
          {submitBtnText('Comment')}
        </Button>
      );
    }
  }, [
    commentToEdit,
    content_group,
    activeTab,
    can_access_submit_approval,
    can_access_accept_request_revision,
    requestDropdownSelectedOption,
    submitDropdownSelectedOption,
    approveDropdownSelectedOption,
    isApprovalButtonDisabled,
    isApprovalActionDisabled,
    isSubmitDisabled,
    handleApprovalAction,
    submitBtnText,
    renderDropdown,
    setRequestDropdownSelectedOption,
    setSubmitDropdownSelectedOption,
    setApproveDropdownSelectedOption,
    updateCommentBtnTextValues,
    approvalButtonVariant,
    buttonClassForContentGroupAction,
    renderButtonContentForApprovalAction
  ]);

  const show_team_tab = can_access_team_comment || can_access_show_team_comment;

  const showTeamTabButtons = () =>{
    return (canAccessPartnerNotes() && canAccessInternalNotes()) || show_team_tab
  }

  return (
    <ChatContext.Provider value={chatContexts}>
      <div className="content-group__chat-panel" ref={scrollContainer}>
        <div className={`chatbtn-group`}>
          <div className={`${isLargeScreen ? 'd-none' : ''} tabs`}>
            { showTeamTabButtons() &&
              <ul className="position-relative">
                { show_team_tab &&
                  <li
                    className={`rounded-pill li-team ${isSubmitDisabled() ? 'disabled' : null} ${activeTab === "internal_notes" ? 'active' : null} `}
                    onClick={ () => isSubmitDisabled() ? false : setActiveTab("internal_notes")}
                  >
                    <div className={`d-flex align-items-stretch justify-content-center ${isSubmitDisabled() ? 'disabled' : ''}`}>
                      Team

                      <div
                        className='d-flex align-items-center justify-content-center position-relative'
                      >
                        <ElementTooltip
                          tooltip_title={'Team'}
                          tooltip_text={tooltipConstants.COMMENT_TEAM}
                          id={'chat_tab-team'}
                          className={'ml-2 d-flex align-items-center'}
                          placement={'auto'}
                        />

                        <div 
                          className='position-absolute d-flex align-items-center ms-2'
                          style={{ top: '50%', left: 12, zIndex: 1, transform: 'translateY(-50%)' }}
                        >
                          <RedDot className={` mx-1 ${content_group?.unread_comments?.team ? 'active' : 'd-none'}`}/>

                          { 
                            isDraftHasValue(internal_draft) && 
                            <DraftCommentIcon className={'mx-1'}/>
                          } 
                        </div>                         
                      </div>
         
                    </div>
                  </li>
                }
                {
                  canAccessPartnerNotes() &&
                  <li
                    className={`rounded-pill li-guest 
                      ${show_team_tab ? '' : 'li-guest--only'} 
                      ${activeTab === "discussion" ? 'active' : null} 
                      ${isSubmitDisabled() ? 'disabled' : ''}`
                    }
                    onClick={ () => isSubmitDisabled() ? false : setActiveTab("discussion")}
                  >
                    <div className={`d-flex align-items-center justify-content-center`}>
                      Guest

                      <div
                        className='d-flex align-items-center justify-content-center position-relative'
                      >
                        <ElementTooltip
                          tooltip_title={'Guest'}
                          tooltip_text={tooltipConstants.COMMENT_APPROVER}
                          id={'chat_tab-approver'}
                          className={'ml-2 d-flex align-items-center'}
                          placement={'left'}
                        />

                         <div 
                          className='position-absolute d-flex align-items-center ms-2'
                          style={{ top: '50%', left: 12, zIndex: 1, transform: 'translateY(-50%)' }}
                        >
                          <RedDot className={`mx-1 ${content_group?.unread_comments?.guest ? '' : 'd-none'}`} />

                          { 
                            isDraftHasValue(partner_draft) && 
                            <DraftCommentIcon className={'mx-1'}/>
                          }
                        </div>
                      </div>
                    </div>
                  </li>
                }
              </ul>
            }
          </div>
          <div className="content-group__chat-toggle-activities d-flex justify-content-end align-items-center">
            <ElementTooltip
              tooltip_title={ activeTab === "internal_notes" ? 'Team' : 'Approver'}
              tooltip_text={activeTab === "internal_notes" ? tooltipConstants.COMMENT_TEAM : tooltipConstants.COMMENT_APPROVER}
              id={'chat_tab-mobile-team'}
              className={`mr-4 d-flex align-items-center ${!isLargeScreen && 'd-none'}`}
              placement={'left'}
            />

            <div className={`cursor-pointer content-group__chat-toggle-activities-button d-flex align-items-center justify-content-center`} onClick={() => handleActive()}>
              {
                showActivities ?
                'Hide Activities' :
                'Show Activities'
              }
            </div>
          </div>
        </div>

        <ChatMessageList
          comments={uniqueComments}
          activeTab={activeTab}
          bottomRef={bottomRef}
          scrollContainerRef={scrollContainerRef}
          showActivities={showActivities}
          getCommentRef={getCommentRef}
          highlightedCommentId={highlightedCommentId}
          selectCommentToReply={selectCommentToReply}
          commentToReplyId={commentToReplyId}
          workspace_id={workspace_id}
          setImagePopUp={setImagePopUp}
          renderParentComment={renderParentComment}
          showTeamTabButtons={showTeamTabButtons}
          has_next_page={has_next_page && isScrolling === false && isRunningCommentRef.current}
          nextPage={nextCommentPage}
          organization_id={currentWorkSpace?.organization_id}
          loading={props?.loading}
          chatFormRef={chatFormRef}
          cardTitleRef={cardTitleRef}
          readOnly={readOnly}
          content_group_id={content_group_id}
        />

        {
          commentToEdit  ?
            <div
              className="selected-reply-container"
            >
              {
                renderCommentToEdit(commentToEdit)
              }
            </div>
          :
            commentToReplyId ?
              <div
                className="selected-reply-container"
              >
                {
                  renderParentComment({parent_id: commentToReplyId})
                }
              </div>
            :
              null
        }

        {can_access_comment && readOnly === false && (
          <div
            className="cursor custom-editor position-relative"
          >
          { isTagSelectorOpen &&
            <UserDropdown
              ref={ tagUserDropdown }
              shouldBeFixed={shouldBeFixed}
              filterText={ tagSelectorText }
              handleSelectUser={ (event, user) => {
                if (user){
                  FieldUserTagSupport.user_selected(inputRef.current, user, searchTag, setChatText)
                } else {
                  processCommentWebSubmit(event)
                }

                setTagSelectorOpen(false);
                setTagSelectorText("");
                setSearchTag("")
              }}
              users={ activeTab == "discussion" ? workspace.users.partner_coordination_objects : workspace.users.internal_coordination_objects }
            />
          }


          <div
            className={`emoji_picker ${showEmojiPopup ? '' : 'd-none'} ${customEmojiClassname}`}
            ref={emojiPickerRef}
          >
            <EmojiPicker
              onEmojiClick={onEmojiClick}
              autoFocusSearch={false}
              searchDisabled
            />
          </div>

          {
            imagePopup.show &&
            <ImagePopup
              handleClose={ () => setImagePopUp({show: false, image_url: null}) }
              image_url={ imagePopup.image_url }
            />
          }

            <div className="chatbox-container position-relative" ref={chatFormRef}>
              { (isDisabled)  &&
                  <div id="chat_overlay" className="position-absolute">
                    <div className="spinner-container">
                      <Spinner animation="border"/>
                    </div>
                  </div>
              }
              <div
                contentEditable={!isSubmitDisabled()}
                id="contenteditable_div"
                className="contentedit_textarea vertical-scroll_thin no-bg mb-2 px-3 py-2 w-100"
                style={{ caretColor: '#787878', minHeight: 46}}
                placeholder={ `${commentPlaceholder()}...` }
                data-placeholder={ `${commentPlaceholder()}...` }
                ref={inputRef}
                onFocus={chatOnFocus}
                onBlur={chatOnBlur}
                onKeyPress={processCommentWebSubmit}
                onKeyDown={onKeyDown}
                onKeyUp={upHandler}
                spellCheck={false}
                autoCorrect={"off"}
                autoComplete={"off"}
                readOnly={false}
                onPaste={(e) => {
                  e.preventDefault();

                  let pastedData = (e.clipboardData || window.clipboardData).getData('text/plain');
                  pastedData = pastedData
                                .split(/\r?\n/)
                                .map(line => {
                                  // Match numbered list or *, -, • bullets
                                  if (/^\s*(\d+\.|\*|-|•)\s+/.test(line)) {
                                    return line.replace(/^\s*(\d+\.|\*|-|•)\s+/, "- ");
                                  }
                                  return line;
                                })
                                .join("\n");
                  const html = addBreakLine(pastedData);

                  const selection = window.getSelection();
                  if (!selection.rangeCount) return;

                  const range = selection.getRangeAt(0);
                  range.deleteContents();

                  // Insert as HTML (including blank lines preserved!)
                  const frag = range.createContextualFragment(html);
                  range.insertNode(frag);
                  range.collapse(false);

                  selection.removeAllRanges();
                  selection.addRange(range);
                  setChatText(pastedData)
                }}
                  onInput={(e) => {
                    const { tag, pretext } = getChatPreText(e);

                    if (tag && tag.length > 0) {
                      setSearchTag(tag[0])
                      updateTagSelector(tag[1])
                    } else {
                      setTagSelectorOpen(false);
                    }

                    if(pretext.length === 0 ) setShowApprovalDropdown((prevState) => false);
                    setChatText(pretext)
                  }} 
                />
              
                {
                  uploadedFiles.length > 0 &&
                  <FormAttachmentThumbnails 
                    uploadedFiles={uploadedFiles}
                    handleDelete={removeHandleFileEvent}
                    commentToEdit={commentToEdit}
                  />
                }
                <div className="d-flex justify-content-between">
                  <div className='content-group__chat-btn-container d-flex'>
                    <label 
                      htmlFor="file-upload" 
                      className="content-group__chat-btn-container__btn--file-upload cursor-pointer d-flex align-items-center justify-content-center"
                    >
                      <PaperClipIcon />
                    </label>
                    <input 
                      id="file-upload" 
                      type="file" 
                      multiple 
                      hidden 
                      ref={uploadFileInputRef} 
                      onChange={handleFileEvent}
                    />

                    <div
                      onClick={handleShowEmojis}
                      onMouseDown={(e) => e.preventDefault()} // stops focus shift
                      onPointerDown={(e) => e.preventDefault()} // for mobile

                      className="content-group__chat-btn-container__btn--emoji cursor-pointer d-flex align-items-center justify-content-center"
                    >
                      <SmileIcon />
                    </div>
                  </div>

                  <div>
                    <div
                      className='chatbutton-container'
                      ref={submitBtnRef}
                    >
                      { renderCommentSubmitButton() }
                    </div>
                  </div>
                </div>
            </div>
          </div>
        )}
      </div>
    </ChatContext.Provider>
  );
}

ChatMessage = reduxForm({
  form: "commentForm",
  validate: validation,
  enableReinitialize: true
})(ChatMessage);

const mapStateToProps = (state, props) => {
  const addressComment = state.comment.addressComment
  return {
    activeTab: state.comment.activeTab,
    loading: state.comment.loading,
    update_comment_loading: state.comment.update_comment_loading,
    draft_attachment_loading: state.comment.draft_attachment_loading,
    draft_render_loading: state.comment.draft_render_loading,
    currentWorkSpace: state.content.currentWorkSpace,
    initialComments: state.comment.comments,
    can_access_accept_revision: state.content.can_access_accept_revision,
    can_access_accept_request_revision: state.content.can_access_accept_request_revision,
    can_access_team_comment: state.content.can_access_team_comment,
    can_access_show_team_comment: state.content.can_access_show_team_comment,
    content_group: state.content.currentContentGroup,
    internal_draft: state.comment.internal_draft,
    partner_draft: state.comment.partner_draft,
    workspace: state.content.currentContentGroupWorkspaceForChat,
    draft_comment_loading: state.comment.draft_comment_loading,
    can_access_comment: state.comment.can_access_comment,
    can_access_submit_approval: state.content.can_access_submit_approval,
    has_next_page: state.comment.has_next_page,
    created_comment: state.comment.created_comment,
    updated_comment: state.comment.updated_comment,
    deleted_comment: state.comment.deleted_comment,
    can_add: state.content.can_add,
    initialValues: {
      content_id: props && props.selected_content_id,
    }
  };
};



export default connect(mapStateToProps, { commentActions })(ChatMessage);
